import { render, staticRenderFns } from "./newNavTop.vue?vue&type=template&id=200fb5d4"
import script from "./newNavTop.vue?vue&type=script&lang=js"
export * from "./newNavTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200fb5d4')) {
      api.createRecord('200fb5d4', component.options)
    } else {
      api.reload('200fb5d4', component.options)
    }
    module.hot.accept("./newNavTop.vue?vue&type=template&id=200fb5d4", function () {
      api.rerender('200fb5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/newNavTop.vue"
export default component.exports